import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
  fetchTickets,
  fetchTicketById,
  createTicketReply,
  updateTicketStatus,
  deleteTicketById
} from '../services/ticketService';


export const useFetchTickets = (currentPage, limit, status, type) => {
  return useQuery({
    queryKey: ['tickets', { currentPage, limit, status, type }],
    queryFn: fetchTickets,
    cacheTime: 5 * 60 * 1000, 
    staleTime: 5 * 60 * 1000,
  });
};


export const useFetchTicketById = (id) => {
  return useQuery({
    queryKey: ['ticket', id],
    queryFn: () => fetchTicketById(id),
    enabled: !!id, 
    cacheTime: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateTicketReply = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTicketReply,
    onSuccess: (data, variables) => {
      toast.success(data.message || 'Reply sent successfully');
      queryClient.invalidateQueries({ queryKey: ['ticket', variables.id] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Error sending reply');
    },
  });
};

export const useUpdateTicketStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }) => updateTicketStatus({ id, status }),
    onSuccess: (data) => {
      toast.success(data.message || 'Ticket status updated successfully');
      queryClient.invalidateQueries(['tickets']);
      queryClient.invalidateQueries({ queryKey: ['ticket', data.ticket?.id] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Error updating ticket status');
    },
  });
};

export const useDeleteTicket = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTicketById,
    onSuccess: (data) => {
      toast.success(data.message || 'Ticket deleted successfully');
      queryClient.invalidateQueries(['tickets']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Error deleting ticket');
    },
  });
};
